export default (i: string) => {
  if (i.endsWith('.') || i.endsWith('.0')) {
    return i;
  }
  if (i.endsWith(',')) {
    return i.replace(',', '.');
  }
  return !!i && !isNaN(Number(i)) ? Number(i) : i;
};
